import { useState } from "react";
import { PanelLeftClose, PanelLeftOpen } from "lucide-react";
import SideBarFull from "./dashboard/SidebarFull";
import SideBarSmall from "./dashboard/SidebarSmall";
import logo from '/images/junfel-logo.svg'
import adminAvatar from "/images/admin-avatar.png";
import { Link } from 'react-router-dom';
import "../styles/sidebar.css";
import { ROUTES } from "../router/appRoutes";

const Sidebar = () => {
	const [open, setOpen] = useState(true);

	const sidebarToggle = () => {
		setOpen((open) => !open);
	};

	return (
		<aside >
			
			<div className="dashboard_menu">
				<div className="dashboard_menu_links">
					<div className="dashboard_panel">
						{open ? (
								<div className="dashboard_icon">
									<Link to={ROUTES.HOME} className="sidebar_logo">
										<img src={logo}	alt="Junfel logo"	className="logo" width={72} height={32}/>
										<span className='version'> &nbsp; v5</span>
									</Link>
								<PanelLeftClose
									width={32}
									className="sidebar_menu_icon sidebar_toggle"
									onClick={sidebarToggle}
								/>
							</div>
						) : (
							
							<div className="dashboard_icon">
									<Link to={ROUTES.HOME} className="sidebar_logo">
										<img
											src={ adminAvatar }
											width={32}
											height={32}
											className="profile_img"
											alt="avatar"
										/>
									</Link>
								<PanelLeftOpen
									width={32}
									className="sidebar_menu_icon sidebar_toggle"
									onClick={sidebarToggle}
								/>
							</div>
						)}
					</div>
					{open ? <SideBarFull /> : <SideBarSmall />}
				</div>
			</div>
		</aside>
	);
};

export default Sidebar;
